module.exports = __webpack_public_path__ + "img/fleet.7b439562.svg";